// Share the CSS palette with the canvas, including the flat scannable QR.
const theme = window.getComputedStyle(document.documentElement);
export const palette = Object.fromEntries(
	[
		"page",
		"ink",
		"line",
		"qr-paper",
		"scene-name",
		"scene-role",
		"scene-location",
		"scene-email",
		"scene-base",
		"scene-qr",
		"scene-ambient",
	].map((name) => [name, theme.getPropertyValue("--" + name).trim()]),
);

export type Palette = typeof palette;

// Canvas frames use the same CSS pixel dimensions as DOM surfaces.
export const frameTokens = {
	borderWidth: Number.parseFloat(theme.getPropertyValue("--border-width")),
	shadowOffset: Number.parseFloat(theme.getPropertyValue("--shadow-offset")),
};
